import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.div`
  --width: 100%;
  --height: 85px;

  & {
    border: 2px solid ${({ theme }) => theme.colors.secondary[900]};
    width: var(--width);
    min-height: var(--height);
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
    position: relative;
    overflow: hidden;
    border-radius: 16px 16px 0 16px;
    font-weight: 300;
    padding: 0;
    line-height: 2;
  }

  &:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  &:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  & > section {
    background-color: inherit;
    padding: 24px 40px;
    margin: 0;
    font-size: var(--fs-500);
    font-weight: 500;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    min-height: var(--height);
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row nowrap;
    line-height: normal;
    cursor: pointer;
    border-radius: 16px 16px 0 22px;
  }

  & > section > figure {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & > section svg {
    width: 26px;
    fill: currentColor !important;
    stroke: currentColor !important;
  }

  & > section > h1 {
    margin: 0 16px 0 0;
  }

  & > article {
    background-color: ${({ theme }) => theme.colors.gray[0]};
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: var(--fs-300);
    padding: 28px 40px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    border-radius: 0 0 0 16px;
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '--height': ['80px', '80px', '85px', '85px'],
        '& > section': {
          fontSize: [
            'var(--fs-50)',
            'var(--fs-50)',
            'var(--fs-500)',
            'var(--fs-500)',
          ],
          padding: ['18px 5%', '18px 5%', '24px 5%', '24px 5%'],
        },
        '& > article': {
          fontSize: [
            'var(--fs-25)',
            'var(--fs-25)',
            'var(--fs-300)',
            'var(--fs-300)',
          ],
          padding: ['18px 5%', '18px 5%', '24px 5%', '24px 5%'],
        },
      }),
    ).styles}}
`

export default Container
